export const getDashboardAchievementsQuery = () =>
  `{
      achievements {
          unlocked
          current_level {
              name
          }
          next_level {
              name
              progress {
                  current
                  target
              }
          }
          recommended_seals {
              key
              name
          }
          stats {
              seals_unlocked
          }
      }
    }`;

export const getLoyaltyAchievementsQuery = () =>
  `{
      achievements {
          unlocked
          current_level {
              level
              name
          }
          next_level {
              level
              name
              seals_remaining
              coupon_value
              progress {
                  current
                  target
              }
          }
          levels {
              level
              name
              achieved
          }
          seals {
              key
              name
              achieved
          }
          stats {
              seals_unlocked
              items_purchased
              items_sold
              coupons_earned
              favourite_category
              favourite_brand {
                  name
              }
          }
      }
    }`;
